import {
  SectorOverviewResponse,
  KwMamboBffCarrierItineraryChangesHandlersGetAlternativesOverview200Response,
  KwMamboBffCarrierItineraryChangesHandlersGetAlternativeItineraryDetails200Response,
} from '@kiwicom/openapi-sdk/mmb';

export const ITINERARY_CHANGE_MOCK_RESPONSE: SectorOverviewResponse = {
  itineraryChange: {
    availability: 'available',
    sectors: [
      {
        sectorId: 22,
        carrierName: 'American Airline',
        isChangeable: true,
        areSeatsTransferred: true,
        segments: [
          {
            arrivalCity: 'London',
            departureCity: 'Prague',
            departureDatetimeLocal: new Date('2025-08-25T09:20:00'),
          },
          {
            arrivalCity: 'Los Angeles',
            departureCity: 'London',
            departureDatetimeLocal: new Date('2025-08-25T09:20:00'),
          },
        ],
      },
      {
        sectorId: 23,
        carrierName: 'American Airline',
        isChangeable: false,
        areSeatsTransferred: false,
        segments: [
          {
            arrivalCity: 'Dallas',
            departureCity: 'Los Angeles',
            departureDatetimeLocal: new Date('2025-08-26T09:20:00'),
          },
        ],
      },
      {
        sectorId: 24,
        carrierName: 'American Airline',
        isChangeable: true,
        areSeatsTransferred: false,
        segments: [
          {
            arrivalCity: 'Los Angeles',
            departureCity: 'Dallas',
            departureDatetimeLocal: new Date('2025-09-10T02:20:00'),
          },
        ],
      },
      {
        sectorId: 25,
        carrierName: 'American Airline',
        isChangeable: true,
        areSeatsTransferred: true,
        segments: [
          {
            arrivalCity: 'Paris',
            departureCity: 'Los Angeles',
            departureDatetimeLocal: new Date('2025-09-14T03:20:00'),
          },
          {
            arrivalCity: 'Prague',
            departureCity: 'Paris',
            departureDatetimeLocal: new Date('2025-09-15T09:20:00'),
          },
        ],
      },
    ],
  },
};

export const ITINERARY_CHANGE_MOCK_RESPONSE_FARE_LIMITATIONS: SectorOverviewResponse = {
  itineraryChange: {
    ...ITINERARY_CHANGE_MOCK_RESPONSE.itineraryChange,
    availability: 'fare_limitations',
  },
};

export const ITINERARY_CHANGE_ALTERNATIVES_OVERVIEW_MOCK_RESPONSE = (
  fareClassName = 'Business',
  date = '2022-06-10',
): KwMamboBffCarrierItineraryChangesHandlersGetAlternativesOverview200Response => ({
  availableFareClasses: ['Economy', 'Premium Economy', 'Business', 'First'],
  fareClassName,
  fareConditionsLink: 'https://www.example.com?fare-conditions',
  alternativeItineraries: [
    {
      alternativeItineraryId: 'a1b-2c3',
      bannersAbove: [],
      priceInfo: { price: { amount: '50.99', currency: 'EUR' } },
      sectors: [
        {
          sectorType: 'success',
          duration: {
            value: 'P1DT0H40M',
          },
          departure: {
            city: 'Prague',
            code: 'PRG',
            datetimeLocal: new Date(`${date}T09:54:00.000Z`),
          },
          arrival: {
            city: 'Los Angeles',
            code: 'LAX',
            datetimeLocal: new Date(`${date}T16:33:00.000Z`),
          },
          carriers: {
            value: [
              {
                name: 'American Airlines',
                carrierIconId: 'AA',
              },
            ],
          },
          vehicleTypes: {
            value: ['airplane'],
          },
          layoverInfo: {
            value: 'Direct',
          },
        },
      ],
    },
    {
      alternativeItineraryId: 'd4e-5f6',
      bannersAbove: [],
      priceInfo: { price: { amount: '-24.12', currency: 'EUR' } },
      sectors: [
        {
          sectorType: 'success',
          duration: {
            value: 'P1DT0H40M',
          },
          departure: {
            city: 'Prague',
            code: 'PRG',
            datetimeLocal: new Date(`${date}T13:14:00.000Z`),
          },
          arrival: {
            city: 'Los Angeles',
            code: 'LAX',
            datetimeLocal: new Date(`${date}T21:53:00.000Z`),
          },
          carriers: {
            value: [
              {
                name: 'American Airlines',
                carrierIconId: 'AA',
              },
            ],
          },
          vehicleTypes: {
            value: ['airplane'],
          },
          layoverInfo: {
            value: '1 stop',
          },
        },
      ],
    },
    {
      alternativeItineraryId: 'g7h-8i9',
      bannersAbove: [],
      priceInfo: { price: { amount: '0', currency: 'EUR' } },
      sectors: [
        {
          sectorType: 'success',
          duration: {
            value: 'P1DT0H40M',
          },
          departure: {
            city: 'Prague',
            code: 'PRG',
            datetimeLocal: new Date(`${date}T11:04:00.000Z`),
          },
          arrival: {
            city: 'Los Angeles',
            code: 'LAX',
            datetimeLocal: new Date(`${date}T21:59:00.000Z`),
          },
          carriers: {
            value: [
              {
                name: 'American Airlines',
                carrierIconId: 'AA',
              },
            ],
          },
          vehicleTypes: {
            value: ['airplane'],
          },
          layoverInfo: {
            value: '1 stop',
          },
        },
      ],
    },
  ],
});

export const ITINERARY_CHANGE_ALTERNATIVE_DETAILS_MOCK_RESPONSE: KwMamboBffCarrierItineraryChangesHandlersGetAlternativeItineraryDetails200Response =
  {
    carrierConditionsLink: 'https://www.example.com?carrier-conditions',
    alternativeItineraryDetails: {
      alternativeItinerary: {
        sectors: [
          {
            segmentGroups: [
              {
                segmentGroupType: 'success',
                segments: [
                  {
                    additionalInfoGroups: [
                      {
                        items: [
                          {
                            icon: 'airplane',
                            name: 'Carrier',
                            value: 'American Airlines',
                          },
                          {
                            icon: 'info',
                            name: 'Connection number',
                            value: 'AA 123',
                          },
                          {
                            icon: 'ticket',
                            name: 'PNR (reservation no.)',
                            value: 'Not available',
                          },
                        ],
                        title: 'Connection info',
                      },
                      {
                        items: [
                          {
                            icon: 'terminal',
                            name: 'Terminal',
                            value: '--',
                          },
                          {
                            icon: 'boarding_gate',
                            name: 'Gate',
                            value: '--',
                          },
                        ],
                        title: 'Departure Info',
                      },
                      {
                        items: [
                          {
                            icon: 'terminal',
                            name: 'Terminal',
                            value: '--',
                          },
                          {
                            icon: 'boarding_gate',
                            name: 'Gate',
                            value: '--',
                          },
                        ],
                        title: 'Arrival Info',
                      },
                    ],
                    arrival: {
                      city: 'Los Angeles',
                      code: 'LAX',
                      datetimeLocal: new Date('2025-04-06T15:55:00'),
                      imageCode: 'los_angeles_us',
                      station: 'Los Angeles International Airport',
                      warning: false,
                    },
                    carrier: {
                      carrierIconId: 'AA',
                      id: 'AA',
                      name: 'American Airlines',
                    },
                    departure: {
                      city: 'Prague',
                      code: 'PRG',
                      datetimeLocal: new Date('2025-04-06T13:55:00'),
                      imageCode: 'prague_cz',
                      station: 'V\u00e1clav Havel Airport Prague',
                      warning: false,
                    },
                    duration: {
                      value: 'PT2H',
                    },
                    hidden: {
                      isSegmentHidden: false,
                      reason: null,
                    },
                    vehicleType: {
                      value: 'airplane',
                    },
                  },
                ],
                title: 'This part is new',
              },
            ],
            title: 'Prague → Los Angeles',
          },
        ],
      },
      alternativeItineraryBanners: [
        {
          description: 'This is a placeholder for banner information',
          icon: 'info',
          title: 'Important information',
          type: 'info',
        },
      ],
      offerExpiresAfterSeconds: 3600,
      originalItinerary: {
        sectors: [
          {
            segmentGroups: [
              {
                segmentGroupType: 'default',
                segments: [
                  {
                    additionalInfoGroups: [
                      {
                        items: [
                          {
                            icon: 'airplane',
                            name: 'Carrier',
                            value: 'Eurowings',
                          },
                          {
                            icon: 'airplane',
                            name: 'Operating carrier',
                            value: 'Eurowings Europe Malta',
                          },
                          {
                            icon: 'info',
                            name: 'Connection number',
                            value: 'EW 4224',
                          },
                          {
                            icon: 'info',
                            name: 'Operating connection number',
                            value: 'E6 4224',
                          },
                          {
                            icon: 'ticket',
                            name: 'PNR (reservation no.)',
                            value: 'Not available',
                          },
                        ],
                        title: 'Connection info',
                      },
                      {
                        items: [
                          {
                            icon: 'terminal',
                            name: 'Terminal',
                            value: '--',
                          },
                          {
                            icon: 'boarding_gate',
                            name: 'Gate',
                            value: '--',
                          },
                        ],
                        title: 'Departure Info',
                      },
                      {
                        items: [
                          {
                            icon: 'terminal',
                            name: 'Terminal',
                            value: '--',
                          },
                          {
                            icon: 'boarding_gate',
                            name: 'Gate',
                            value: '--',
                          },
                        ],
                        title: 'Arrival Info',
                      },
                    ],
                    arrival: {
                      city: 'Los Angeles',
                      code: 'LAX',
                      datetimeLocal: new Date('2025-04-06T15:20:00'),
                      imageCode: 'los_angeles_us',
                      station: 'Los Angeles International Airport',
                      warning: false,
                    },
                    carrier: {
                      carrierIconId: 'EW',
                      id: 'EW',
                      name: 'Eurowings',
                    },
                    departure: {
                      city: 'Prague',
                      code: 'PRG',
                      datetimeLocal: new Date('2025-04-06T11:55:00'),
                      imageCode: 'prague_cz',
                      station: 'V\u00e1clav Havel Airport Prague',
                      warning: false,
                    },
                    duration: {
                      value: 'PT3H25M',
                    },
                    hidden: {
                      isSegmentHidden: false,
                      reason: null,
                    },
                    vehicleType: {
                      value: 'airplane',
                    },
                  },
                ],
                title: '',
              },
            ],
            title: 'Prague → Los Angeles',
          },
        ],
      },
      title: 'Lorem ipsum',
      totalPrice: {
        amount: '50.99',
        currency: 'EUR',
      },
    },
  };
